import client from "./client";

export default {
    async getSmsLogs(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/sms-logs', filters)));
    },

    async resendSms(data) {
        return client.parseResponse(await client.get('/resend-sms/' + data.id));
    },

    // campaigns
    async getCampaigns(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/campaigns', filters)));
    },
    async getBalance(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/sms-balance', filters)));
    },
    async createCampaign(data) {
        return client.parseResponse(await client.upload('/campaigns', data))
    },
    async loadUnits(data) {
        return client.parseResponse(await client.upload('/recharge-sms-units', data))
    },
    async editCampaign(data) {
        return client.parseResponse(await client.upload('/update-campaign', data))
    },
    async getRecipients(data) {
        return client.parseResponse(client.parseResponse(await client.get('/campaign-recipients', data)));
    },
    async getCampaign(id) {
        return client.parseResponse(await client.get('/campaigns/' + id));
    },
}
